import React from 'react';
import { BarChart2Icon } from 'lucide-react';
interface PrimalRow {
  name: string;
  select: {
    price: string;
    change: string;
    isNegative: boolean;
  };
  choice: {
    price: string;
    change: string;
    isNegative: boolean;
  };
  spread: {
    price: string;
    change: string;
    isNegative: boolean;
  };
}
const primalData: PrimalRow[] = [{
  name: 'Cutout',
  select: {
    price: '$3.84',
    change: '+0.02',
    isNegative: false
  },
  choice: {
    price: '$3.82',
    change: '+0.01',
    isNegative: false
  },
  spread: {
    price: '$-0.02',
    change: '-0.01',
    isNegative: true
  }
}, {
  name: 'Primal Brisket',
  select: {
    price: '$3.38',
    change: '-0.01',
    isNegative: true
  },
  choice: {
    price: '$3.48',
    change: '+0.02',
    isNegative: false
  },
  spread: {
    price: '$0.10',
    change: '+0.03',
    isNegative: false
  }
}, {
  name: 'Primal Chuck',
  select: {
    price: '$3.34',
    change: '+0.11',
    isNegative: false
  },
  choice: {
    price: '$3.17',
    change: '-0.01',
    isNegative: true
  },
  spread: {
    price: '$-0.17',
    change: '-0.12',
    isNegative: true
  }
}, {
  name: 'Primal Flank',
  select: {
    price: '$2.26',
    change: '+0.00',
    isNegative: false
  },
  choice: {
    price: '$2.23',
    change: '+0.02',
    isNegative: false
  },
  spread: {
    price: '$-0.02',
    change: '+0.02',
    isNegative: false
  }
}, {
  name: 'Primal Loin',
  select: {
    price: '$5.10',
    change: '-0.00',
    isNegative: true
  },
  choice: {
    price: '$5.12',
    change: '+0.02',
    isNegative: false
  },
  spread: {
    price: '$0.02',
    change: '+0.02',
    isNegative: false
  }
}, {
  name: 'Primal Plate',
  select: {
    price: '$3.01',
    change: '-0.04',
    isNegative: true
  },
  choice: {
    price: '$3.01',
    change: '-0.04',
    isNegative: true
  },
  spread: {
    price: '$0.00',
    change: '+0.00',
    isNegative: false
  }
}, {
  name: 'Primal Rib',
  select: {
    price: '$5.12',
    change: '-0.05',
    isNegative: true
  },
  choice: {
    price: '$5.41',
    change: '+0.09',
    isNegative: false
  },
  spread: {
    price: '$0.29',
    change: '+0.13',
    isNegative: false
  }
}, {
  name: 'Primal Round',
  select: {
    price: '$3.24',
    change: '+0.00',
    isNegative: false
  },
  choice: {
    price: '$3.20',
    change: '+0.00',
    isNegative: false
  },
  spread: {
    price: '$-0.04',
    change: '+0.00',
    isNegative: false
  }
}];
function ChangeText({
  value,
  isNegative
}: {
  value: string;
  isNegative: boolean;
}) {
  return <span className={`text-xs ${isNegative ? 'text-red-600' : 'text-green-600'}`} data-id="element-324">
      {value}
    </span>;
}
export function SubprimalsTable() {
  return <div className="mb-12" data-id="element-325">
      {/* Header */}
      <div className="mb-4" data-id="element-326">
        <div className="flex items-center gap-2 mb-1" data-id="element-327">
          <BarChart2Icon className="w-5 h-5 text-gray-700" data-id="element-328" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-329">
            Composite Primal Values
          </h3>
        </div>
        <p className="text-sm text-gray-500" data-id="element-330">04/13/26 – $/lb</p>
      </div>

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-331">
        <table className="w-full text-sm" data-id="element-332">
          <thead data-id="element-333">
            <tr className="border-b border-gray-200" data-id="element-334">
              <th className="text-left py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-335">
                Primal Cut
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-336">
                Select
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-337">
                Choice
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-338">
                Spread
              </th>
            </tr>
          </thead>
          <tbody data-id="element-339">
            {primalData.map((row, idx) => <tr key={idx} className={`border-b border-gray-100 ${idx === 0 ? 'bg-gray-50 font-semibold' : ''}`} data-id="element-340">
                <td className="py-4 px-4 text-gray-900 font-medium" data-id="element-341">
                  {row.name}
                </td>
                <td className="py-4 px-4 text-right" data-id="element-342">
                  <div className="font-semibold text-gray-900" data-id="element-343">
                    {row.select.price}
                  </div>
                  <ChangeText value={row.select.change} isNegative={row.select.isNegative} data-id="element-344" />
                </td>
                <td className="py-4 px-4 text-right" data-id="element-345">
                  <div className="font-semibold text-gray-900" data-id="element-346">
                    {row.choice.price}
                  </div>
                  <ChangeText value={row.choice.change} isNegative={row.choice.isNegative} data-id="element-347" />
                </td>
                <td className="py-4 px-4 text-right" data-id="element-348">
                  <div className="font-semibold text-gray-900" data-id="element-349">
                    {row.spread.price}
                  </div>
                  <ChangeText value={row.spread.change} isNegative={row.spread.isNegative} data-id="element-350" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Deep Dive Link */}
      <div className="mt-4 flex justify-end" data-id="element-351">
        <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-[#002f5f] hover:underline flex items-center gap-1" data-id="element-352">
          View Detailed Analysis
          <BarChart2Icon className="w-3 h-3" data-id="element-353" />
        </a>
      </div>
    </div>;
}